import { AuthState, AuthReducer } from './auth/auth.reducers';
import { AuthEffects } from './auth/auth.effects';
import * as fromCommon from './common/common.reducer';
import * as fromOrders from './order/order.reducer';
import { OrdersEffects } from './order/order.effects';
import * as fromInvoices from './invoice/invoice.reducer';
import { InvoiceEffects } from './invoice/invoice.effects';
import * as fromDrawerState from './drawer-state/drawer-state.reducer';
import { DrawerStateEffects } from './drawer-state/drawer-state.effects';
import * as fromCustomer from './customer/customer.reducer';
import { CustomerEffects } from './customer/customer.effects';
import * as fromConsultation from './consultation/consultation.reducer';
import { ConsultationEffects } from './consultation/consultation.effects';
import * as fromPrescription from './prescription/prescription.reducer';
import { PrescriptionEffects } from './prescription/prescription.effects';
import * as fromDrug from './drug/drug.reducer';
import { DrugEffects } from './drug/drug.effects';
import * as fromNote from './note/note.reducer';
import { NoteEffects } from './note/note.effects';
import * as fromMessage from './message/message.reducer';
import { MessageEffects } from './message/message.effects';
import * as fromFile from './file/file.reducer';
import { FileEffects } from './file/file.effects';
import * as fromNotification from './notification/notification.reducer';
import { NotificationEffects } from './notification/notification.effects';
import * as fromApp from './app/app.reducer';
import { AppEffects } from './app/app.effects';
import * as fromAppointment from './appointment/appointment.reducer';
import { AppointmentEffects } from './appointment/appointment.effects';
import * as fromSubscriptions from './subscriptions/subscriptions.reducer';
import { SubscriptionsEffects } from './subscriptions/subscriptions.effects';
import * as fromAdminUser from './admin-user/admin-user.reducer';
import { AdminUserEffects } from './admin-user/admin-user.effects';
import * as fromLabReq from './lab-req/lab-req.reducer';
import { LabReqEffects } from './lab-req/lab-req.effects';
import * as fromLabResults from './lab-results/lab-results.reducer';
import { LabResultsEffects } from './lab-results/lab-results.effects';
import * as fromChat from './chat/chat.reducer';
import { ChatEffects } from './chat/chat.effects';
import * as fromSchedule from './+schedules/schedules.reducer';
import { SchedulesEffects } from './+schedules/schedules.effects';
import * as fromTasks from './tasks/tasks.reducer';
import { TaskEffects } from './tasks/tasks.effects';
import * as fromCannedMessages from './canned-messages/canned-messages.reducer';
import { CannedMessageEffects } from './canned-messages/canned-messages.effects';
import * as fromProduct from './product/product.reducer';
import { ProductEffects } from './product/product.effects';

export interface AppState {
  auth: AuthState;
  [fromApp.APP_FEATURE_KEY]: fromApp.State;
  [fromAdminUser.ADMIN_USER_FEATURE_KEY]: fromAdminUser.State;
  [fromCommon.COMMON_FEATURE_KEY]: fromCommon.State;
  [fromOrders.ORDERS_FEATURE_KEY]: fromOrders.State;
  [fromInvoices.INVOICE_FEATURE_KEY]: fromInvoices.State;
  [fromDrawerState.DRAWERSTATE_FEATURE_KEY]: fromDrawerState.State;
  [fromCustomer.CUSTOMER_FEATURE_KEY]: fromCustomer.State;
  [fromConsultation.CONSULTATION_FEATURE_KEY]: fromConsultation.State;
  [fromPrescription.PRESCRIPTION_FEATURE_KEY]: fromPrescription.State;
  [fromDrug.DRUG_FEATURE_KEY]: fromDrug.State;
  [fromNote.NOTE_FEATURE_KEY]: fromNote.State;
  [fromMessage.MESSAGE_FEATURE_KEY]: fromMessage.State;
  [fromFile.FILE_FEATURE_KEY]: fromFile.State;
  [fromNotification.NOTIFICATIONS_FEATURE_KEY]: fromNotification.State;
  [fromAppointment.APPOINTMENT_FEATURE_KEY]: fromAppointment.State;
  [fromSubscriptions.SUBSCRIPTIONS_FEATURE_KEY]: fromSubscriptions.State;
  [fromLabReq.LAB_REQ_FEATURE_KEY]: fromLabReq.State;
  [fromLabResults.LAB_RESULTS_FEATURE_KEY]: fromLabResults.State;
  [fromChat.CHAT_FEATURE_KEY]: fromChat.State;
  [fromSchedule.SCHEDULES_FEATURE_KEY]: fromSchedule.State;
  [fromTasks.TASK_FEATURE_KEY]: fromTasks.State;
  [fromCannedMessages.CANNED_MESSAGES_FEATURE_KEY]: fromCannedMessages.State;
  [fromProduct.PRODUCT_FEATURE_KEY]: fromProduct.State;
}

export const reducers = {
  auth: AuthReducer,
  [fromApp.APP_FEATURE_KEY]: fromApp.reducer,
  [fromAdminUser.ADMIN_USER_FEATURE_KEY]: fromAdminUser.reducer,
  [fromCommon.COMMON_FEATURE_KEY]: fromCommon.reducer,
  [fromOrders.ORDERS_FEATURE_KEY]: fromOrders.reducer,
  [fromInvoices.INVOICE_FEATURE_KEY]: fromInvoices.reducer,
  [fromDrawerState.DRAWERSTATE_FEATURE_KEY]: fromDrawerState.reducer,
  [fromCustomer.CUSTOMER_FEATURE_KEY]: fromCustomer.reducer,
  [fromConsultation.CONSULTATION_FEATURE_KEY]: fromConsultation.reducer,
  [fromPrescription.PRESCRIPTION_FEATURE_KEY]: fromPrescription.reducer,
  [fromDrug.DRUG_FEATURE_KEY]: fromDrug.reducer,
  [fromNote.NOTE_FEATURE_KEY]: fromNote.reducer,
  [fromMessage.MESSAGE_FEATURE_KEY]: fromMessage.reducer,
  [fromFile.FILE_FEATURE_KEY]: fromFile.reducer,
  [fromNotification.NOTIFICATIONS_FEATURE_KEY]: fromNotification.reducer,
  [fromAppointment.APPOINTMENT_FEATURE_KEY]: fromAppointment.reducer,
  [fromSubscriptions.SUBSCRIPTIONS_FEATURE_KEY]: fromSubscriptions.reducer,
  [fromLabReq.LAB_REQ_FEATURE_KEY]: fromLabReq.reducer,
  [fromLabResults.LAB_RESULTS_FEATURE_KEY]: fromLabResults.reducer,
  [fromChat.CHAT_FEATURE_KEY]: fromChat.reducer,
  [fromSchedule.SCHEDULES_FEATURE_KEY]: fromSchedule.reducer,
  [fromTasks.TASK_FEATURE_KEY]: fromTasks.reducer,
  [fromCannedMessages.CANNED_MESSAGES_FEATURE_KEY]: fromCannedMessages.reducer,
  [fromProduct.PRODUCT_FEATURE_KEY]: fromProduct.reducer
};

export const effects = [
  AppEffects,
  AdminUserEffects,
  AuthEffects,
  OrdersEffects,
  InvoiceEffects,
  DrawerStateEffects,
  CustomerEffects,
  ConsultationEffects,
  PrescriptionEffects,
  DrugEffects,
  NoteEffects,
  MessageEffects,
  FileEffects,
  NotificationEffects,
  AppointmentEffects,
  SubscriptionsEffects,
  LabReqEffects,
  LabResultsEffects,
  ChatEffects,
  SchedulesEffects,
  TaskEffects,
  CannedMessageEffects,
  ProductEffects
];
